/**
 * Цвет зоны арендатора — устойчивый по id: один арендатор всегда одного цвета.
 *
 * Отдельный файл не «на всякий случай»: карточка арендатора берёт отсюда цвет,
 * а раньше импортировала его из interior.ts — и вместе с одной функцией в
 * СТАРТОВУЮ загрузку страницы попадал весь three.js (228 КБ). Здесь чистая
 * арифметика без зависимостей, поэтому 3D-код грузится только когда его открыли.
 */
const PALETTE = [0x22d3ee, 0x818cf8, 0x34d399, 0xf59e0b, 0xf472b6, 0x60a5fa, 0xa3e635, 0xfb7185]

export function zoneColor(id: string): number {
  let hash = 0
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0
  return PALETTE[hash % PALETTE.length] as number
}
